module.exports = __webpack_public_path__ + "static/img/capacity_end.3d77d58a.png";